//jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	  // $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	  //   // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	  // });
//});

window.addEventListener('DOMContentLoaded', () => {
  const css = `
    #cust_filter_wrapper {
      display: none;
    }
    @media only screen and (min-width: 720px) {
      #cust_filter_wrapper {
        display: block;
      }
      #cust_filter_wrapper .t4s-drawer__main .t4s-drawer__scroll {
        position: relative !important;
        min-width: 320px;
        overflow: visible;
        padding: 22px;
      }
      .cust_collection_wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
      }
      .cust_collection_wrapper .t4s-main-area {
        width: calc(100% - 330px) !important;
      }
      .t4s-btn-filter-wrapper > button {
        display: none !important;
      }
      #cust_filter_wrapper .t4s-drawer[aria-hidden=false] {
        position: relative;
        display: block;
      }
      #cust_filter_wrapper .t4s-drawer__close {
        display: none !important;
      }
    }
  `;

 

  function sidebar() {
     const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.type = 'text/css';
  head.appendChild(style);
    const element = document.getElementById('t4s-filter-hidden');
    const newParent = document.getElementById('cust_filter_wrapper');

    if (element && newParent) {
      newParent.appendChild(element);
      element.setAttribute("aria-hidden", "false");

      if (style.styleSheet) {
        // For IE8 and below
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
    }
  }

  function check_sidebar() {
    setTimeout(() => {
      if (document.getElementById('t4s-filter-hidden')) {
        sidebar();
      } else {
        check_sidebar();
      }
    }, 100);
  }

  if (window.innerWidth > 720) {
    check_sidebar();
  }
});